<template>
    <ComboboxOption
        v-slot="{ active, selected }"
        :disabled="disabled"
        as="template">
        <li
            :class="['relative cursor-default select-none py-2 pl-3 pr-9', active
                ? 'bg-primary text-white'
                : disabled ? 'text-gray-500' : 'text-gray-900 dark:text-gray-300']">
            <span class="block">
                <slot>
                    <span :class="[{'truncate' : truncate}]">
                        {{ label }}
                    </span>
                    <span
                        v-if="additional"
                        class="text-xs text-gray-400"
                        :class="[{'truncate' : truncate}]">
                        <br>{{ additional }}
                    </span>
                </slot>
            </span>

            <span
                v-if="selected"
                :class="['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-primary-500']">
                <Icon
                    name="check"
                    size="5"
                    aria-hidden="true" />
            </span>
        </li>
    </ComboboxOption>
</template>

<script setup lang="ts">
defineProps({
    truncate: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        required: true
    },
    additional: {
        type: String,
        default: null
    },
    disabled: {
        type: Boolean,
        default: false
    },
})


</script>